import { startLoading } from '../utils/loader';

function isLocalhostUrl(value) {
  return /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(value);
}

export function getApiBaseUrl() {
  const configured = process.env.REACT_APP_API_BASE_URL?.trim();

  if (configured) {
    if (
      typeof window !== 'undefined' &&
      window.location?.origin &&
      isLocalhostUrl(configured) &&
      !['localhost', '127.0.0.1'].includes(window.location.hostname)
    ) {
      return window.location.origin;
    }

    return configured.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  if (process.env.NODE_ENV === 'production') {
    return '';
  }

  return 'http://localhost:4000';
}

const AUTO_MESSAGE = { POST: 'Saving…', PUT: 'Saving changes…', DELETE: 'Deleting…' };

/**
 * options.silent: no "please wait" backdrop (background calls).
 * options.loadingMessage: text shown on the backdrop instead of "Saving…".
 * GET requests never show the backdrop; pages show their own loader.
 */
async function request(path, options = {}) {
  const { silent, loadingMessage, ...fetchOptions } = options;
  const method = (fetchOptions.method || 'GET').toUpperCase();
  const task =
    !silent && method !== 'GET'
      ? startLoading(loadingMessage || AUTO_MESSAGE[method] || 'Please wait…', { auto: !loadingMessage })
      : null;
  try {
    return await send(path, fetchOptions);
  } finally {
    task?.done();
  }
}

async function send(path, options) {
  const token = localStorage.getItem('authToken');

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${getApiBaseUrl()}${path}`, {
    ...options,
    headers,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message =
      data.message ||
      data.errors?.[0]?.message ||
      'Something went wrong. Please try again.';

    throw new Error(message);
  }

  return data;
}

export function unwrapResponse(res) {
  if (res && typeof res === 'object' && Object.prototype.hasOwnProperty.call(res, 'data')) {
    return res.data;
  }

  return res;
}

export const api = {
  get: (path, options) => request(path, options),
  post: (path, body, options) =>
    request(path, {
      ...options,
      method: 'POST',
      body: JSON.stringify(body),
    }),
  put: (path, body, options) =>
    request(path, {
      ...options,
      method: 'PUT',
      body: JSON.stringify(body),
    }),
  delete: (path, options) =>
    request(path, {
      ...options,
      method: 'DELETE',
    }),
};

export default getApiBaseUrl;
